import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import bgImage from '../../assets/login-bg.svg';
import logoUrl from '../../assets/metso_logo_black.svg';

// const _urlPrefix =
//   process.env.NODE_ENV !== 'production' ? 'http://localhost:5000' : '';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  background-position: bottom right;
  background-image: url(${bgImage});
`;

const Title = styled.h1`
  font-size: 2.25rem;
  font-weight: 200;
  margin-top: 0;
  margin-bottom: 30px;
`;

const TitleSmall = styled.p`
  font-size: 1.375rem;
  font-weight: 600;
  margin-bottom: 0px;
`;

const Logo = styled.img`
  position: absolute;
  top: 30px;
  left: 30px;
  width: 124px;
`;

const Version = styled.div`
  position: fixed;
  bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
`;

const LoginContainer = () => {
  const {
    loginWithRedirect,
    isAuthenticated,
    user,
    logout,
    isLoading,
    error,
  } = useAuth0();

  if (isLoading) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>Loading...</TitleSmall>
        <Title>Please wait</Title>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>Authentication Error</TitleSmall>
        <Title>{error.message}</Title>
        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </ButtonContainer>
      </Container>
    );
  }

  if (isAuthenticated && user) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>Welcome back!</TitleSmall>
        <Title>{user.name}</Title>
        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => (window.location.href = '/')}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
          >
            Logout
          </Button>
        </ButtonContainer>
        <Version>{process.env.REACT_APP_VERSION}</Version>
      </Container>
    );
  }

  return (
    <Container>
      <Logo alt="Metso Logo" src={logoUrl} />
      <TitleSmall>Welcome to</TitleSmall>
      <Title>Crusher wears product catalog</Title>
      <ButtonContainer>
        <Button
          id="auth0LoginBtn"
          variant="contained"
          color="primary"
          size="large"
          onClick={() => loginWithRedirect()}
        >
          Login with Metso account
        </Button>
      </ButtonContainer>
      <Version>{process.env.REACT_APP_VERSION}</Version>
    </Container>
  );
};

export default LoginContainer;
